import React from 'react';
import PropTypes from 'prop-types';
import FontAwesome from 'react-fontawesome';

import {Utils} from '../../Api';
import Button from '../../components/Button';
import Processing from '../../components/Processing';

export default class Brand extends React.Component {
  static propTypes = {
    brand: PropTypes.object.isRequired,
    count: PropTypes.number,
    cost: PropTypes.number,
    className: PropTypes.string,
    addToBag: PropTypes.func,
    title: PropTypes.string.isRequired,
    url: PropTypes.string
  };

  constructor(props) {
    super(props);
    this.onScroll = this.onScroll.bind(this);
  }

  componentDidMount() {
    window.addEventListener('scroll', this.onScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.onScroll);
  }

  onScroll() {
    const distance = window.pageYOffset || window.document.documentElement.scrollTop;
    const minimizeThreshold = this.$component.clientHeight;

    if (distance < minimizeThreshold) {
      this.$component.classList.remove('collapse');
    } else {
      if (!this.$component.classList.contains('collapse')) {
        this.$component.classList.add('collapse');
      }
    }
  }

  render() {
    let classNames = ['product-collection-brand-component'];
    if (this.props.className) classNames.push(this.props.className);

    let closestText = null;
    if (this.props.closestBrandRetailer) {
      closestText = <span><FontAwesome name="map-marker"/> Nearest store carrying {this.props.brand.name}
        <strong>{parseInt(this.props.closestBrandRetailer, 10)} miles away</strong></span>
    }

    let fromText = null;
    if (this.props.brand.from) fromText = <div className="from">{this.props.brand.from}</div>;

    let minimumText = null;
    if (this.props.brand.minimum_order_amount_cents) {
      minimumText = <div className="brand-minimum">Minimum
        ${Utils.formatCents(this.props.brand.minimum_order_amount_cents, true)}</div>
    }

    let urlText = null;
    if (this.props.url && this.props.url.length > 0) {
      urlText = <div className="site">{this.props.url}</div>;
    }

    let button = null;
    if (this.props.loading) {
      button = <Processing />;
    } else {
      button = <Button onClick={this.props.addToBag} disabled={!this.props.count}>Add Collection to Bag</Button>;
    }

    let brandInfoHidden = !fromText && !urlText && !minimumText;
    let brandInfo = null;
    if (!brandInfoHidden) {
      brandInfo = (
        <div className="brand-info">
          {fromText}
          {urlText}
          {minimumText}
        </div>
      );
    }

    return (
      <div className={classNames.join(' ')} ref={(div) => {this.$component = div}}>
        <div className="contents">
          <div className="topbar">
            <div className="social" />
            <div className="closest">{closestText}</div>
          </div>
          <div className="name">{this.props.title}</div>
          {brandInfo}
          <div className="description">{this.props.description}</div>
          <div className="collection-info">
            <div className="count">{this.props.count || 0} Items</div>
            <div className="cost">Total Cost <span
              className="value">${Utils.formatCents(this.props.cost, true) || '0'}</span></div>
          </div>
          <div className="button-wrapper">{button}</div>
          <div className="collection-contents-header">Collection Contents</div>
        </div>
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/views/collection/brand.js
 **/